import { createGlobalStyle } from 'styled-components';
import type { NextFont } from 'next/dist/compiled/@next/font';

interface Props {
  font: NextFont;
}

/**
 * This is required to overwrite the font-family on zopa react-components
 *
 * TODO: Remove once ZRC no longer defines font-family on every individual component
 */
export const AppGlobalStyles = createGlobalStyle<Props>`
  * { font-family: ${({ font }) => font.style.fontFamily} !important; }
`;
